@if (isRankingEnable) { @if ($data | async; as rank) {
<div class="pt-4">
    <h6 class="match-info-head text-white mb-0 text-uppercase bg-dark p-2">{{ 'web.ranking' | translate }}</h6>
    <ul class="nav nav-tabs" id="tennisRankingTab" role="tablist">
        @for (nav of rank; track $index; let isFirst = $first) {
        <li class="nav-item">
            <a
                class="nav-link"
                [class.active]="isFirst"
                id="rankingTab-{{ nav[0] }}"
                data-toggle="tab"
                href="#tab-ranking-{{ nav[0] }}"
                role="tab"
                aria-controls="info"
                [attr.ariaSelected]="isFirst ? 'true' : 'false'"
            >
                {{ 'web.' + nav[0] | translate }}
            </a>
        </li>
        }
    </ul>
    <div class="tab-content">
        @for (nav of rank; track $index; let isFirst = $first) {
        <div
            class="tab-pane"
            [class.active]="isFirst"
            id="tab-ranking-{{ nav[0] }}"
            role="tabpanel"
            aria-labelledby="home-tab"
        >
            @if (nav[1].length > 0) {
            <div class="d-flex table-scrollable" style="overflow: auto">
                <div
                    class="table-scrollable__data flex-grow-1"
                    tableScroll
                    style="overflow: clip; overflow-y: unset !important"
                >
                    <table class="table-scrollable__data__table table table-tennis-ranking">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'web.rank' | translate }}</th>
                                <th scope="col">&nbsp;</th>
                                <th scope="col">{{ 'web.player_name' | translate }}</th>
                                <!-- <th *ngIf="sportName === 'golf'" scope="col">{{ 'web.prior_rank' | translate }}</th> -->
                                <th scope="col" class="text-right">{{ pointName | translate }}</th>
                                @if (sportName === 'golf') {
                                <th scope="col" class="text-right">
                                    {{ 'web.avg_points' | translate }}
                                </th>
                                } @if (sportName === 'golf') {
                                <th scope="col" class="text-right">
                                    {{ 'web.points_lost' | translate }}
                                </th>
                                } @if (sportName === 'golf') {
                                <th scope="col" class="text-right">
                                    {{ 'web.points_gained' | translate }}
                                </th>
                                } @if (sportName === 'golf') {
                                <th scope="col" class="text-right">
                                    {{ 'web.events_played' | translate }}
                                </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (player of nav[1] | slice : 0 : slice; track $index; let isFirst2 = $first) {
                            <tr [class.tennis-ranking-first-row]="isFirst2">
                                <th scope="row" [class.tennis-ranking-first]="isFirst2">
                                    {{ player.ranking }}
                                </th>
                                <td class="text-center">
                                    @if (player.info.image_country !== null && !isFirst2) {
                                    <img
                                        src="{{ player.info.image_country }}"
                                        alt="{{ player.info.name }}"
                                        width="16"
                                        class="mr-2 rounded-circle"
                                    />
                                    } @if (player.info.image !== null && isFirst2) {
                                    <img
                                        src="{{ player.info.image }}"
                                        alt="{{ player.info.name }}"
                                        style="width: 60px"
                                        class="img-fluid rounded-circle"
                                    />
                                    }
                                </td>
                                <td [class.tennis-ranking-first]="isFirst2">
                                    <a
                                        [routerLink]="[
                                            '/page/' +
                                                (sportName === 'golf' ? 'golf' : 'sport') +
                                                '/participant/' +
                                                sportName +
                                                '-' +
                                                sportId +
                                                '/' +
                                                player.participantId
                                        ]"
                                        class="text-reset"
                                        >{{ player.info.name }}</a
                                    >
                                </td>
                                <!-- <td *ngIf="sportName === 'golf'">
                            {{ player.prior_rank }}
                          </td> -->
                                <td [class.tennis-ranking-first]="isFirst2" class="text-right">
                                    @if (isPrizeMoney) {
                                    {{ player.prizeMoney | localeCurrency : 'GBP' }}
                                    } @if (isPoints) {
                                    {{ player.points }}
                                    }
                                </td>
                                @if (sportName === 'golf') {
                                <td class="text-center">
                                    {{ player.avg_points }}
                                </td>
                                } @if (sportName === 'golf') {
                                <td class="text-center">
                                    {{ player.points_lost }}
                                </td>
                                } @if (sportName === 'golf') {
                                <td class="text-center">
                                    {{ player.points_gained }}
                                </td>
                                } @if (sportName === 'golf') {
                                <td class="text-center">
                                    {{ player.events_played }}
                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                    </table>
                    <div class="mt-1 mb-2 text-center">
                        @if (slice == 10) {
                        <a (click)="slice = 500" class="text-reset app-cursor">{{ 'web.show_more' | translate }}</a>
                        } @if (slice == 500) {
                        <a (click)="slice = 10" class="text-reset app-cursor">{{ 'web.show_less' | translate }}</a>
                        }
                    </div>
                </div>
            </div>
            }
        </div>
        }
    </div>
</div>
} @else { } }
